import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { showSpinner, showModal } from '../../actions'
import OfferBoardCatalogue from './OfferBoardCatalogue'

const mapStateToProps = (state) => {
  return {
    userId: state.user.data._id
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ showSpinner, showModal }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferBoardCatalogue)
